export interface FunctionalLifestyleRating {
  key: string;
  label: string;
  value: number;
  description?: string;
}

// Rating scale: 1-10
export const RATING_SCALE = {
  MIN: 1,
  MAX: 10,
} as const;

// Health metrics labels for display
export const HEALTH_METRICS = [
  { key: "energyLevels", label: "Energy Levels" },
  { key: "mentalClarityFocus", label: "Mental Clarity & Focus" },
  { key: "moodEmotionalWellbeing", label: "Mood & Emotional Wellbeing" },
  { key: "libidoSexualHealth", label: "Libido & Sexual Health" },
  { key: "digestion", label: "Digestion" },
  { key: "immuneFunction", label: "Immune Function" },
  { key: "fitnessLevel", label: "Fitness Level" },
  { key: "skinAppearance", label: "Skin Appearance" },
  { key: "hairHealth", label: "Hair Health" },
  { key: "sleep", label: "Sleep" },
  { key: "additionalInformation", label: "Additional Information" },
] as const;

export type HealthMetricKey = (typeof HEALTH_METRICS)[number]["key"];
